<template>
  <div style="height: 100%; max-width: 500px" class="mx-auto">
    <div>
      <slot name="header"></slot>
      <v-stepper
        class="elevation-0 pa-0"
        v-model="step"
        style="border-radius: 0px"
      >
        <v-stepper-content class="pa-0" step="1">
          <step-1 @nextstep="step++"></step-1>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="2">
          <OTP v-if="step == 2" @nextstep="changePassword"></OTP>
        </v-stepper-content>
        <!-- <v-stepper-content class="pa-0" step="3">
          <step-2 v-if="step == 3"></step-2>
        </v-stepper-content> -->
      </v-stepper>
    </div>
  </div>
</template>

<script>
import Step1 from "./Step1.vue";
// import Step2 from "./Step2.vue";
import OTP from "@/components/OTP.vue";

export default {
  components: {
    Step1,
    OTP,
  },
  data() {
    return {
      step: 1,
      showTerm: false,
    };
  },

  mounted() {},
  methods: {
    changePassword() {
      let query = this.$store.state.query;
      query.view = "ForgetPassword2";
      query.apptype = "line";
      query.memberId = this.$store.state.forgetPasswordData.memberId;
      query.pageid = "100701258941039";
    },
  },
};
</script>

<style lang="scss" scoped></style>
